import { Redirect, Route, useLocation } from 'react-router-dom'

const whiteList = ['/login', '/authredirect', '/404']

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (localStorage.getItem('token')) {
          // getUserInfo(); // 获取用户信息，用于前端监控系统
          if (props.location === 'login') {
            return (
              <Redirect
                to={{
                  pathname: '/login',
                }}
              />
            )
          } else {
            return <Component {...props} />
          }
        } else {
          if (whiteList.indexOf(props.location) >= 0) {
            return <Component {...props} />
          } else {
            return (
              <Redirect
                to={{
                  pathname: '/login',
                  search: '?redirect=' + props.match.url,
                }}
              />
            )
          }
        }
      }}
    />
  )
}
export default PrivateRoute
